import React from 'react'
import '../Styles/gallery.css'

import foto1 from "../Assets/recipientes/recipiente.jpg"
import foto2 from "../Assets/recipientes/recipiente2.jpg"
import foto3 from "../Assets/recipientes/recipiente3.jpg"
import foto4 from "../Assets/recipientes/recipiente.jpg"


const Gallery = () => {
    return (
        <div className="gal">
            <h1 className="titulo">RECIPIENTES BIODEGRADABLES</h1>
            <div className="galeria" id="RECIPIENTES">
                <a href="#imagenr1">
                    <img src={foto1} alt=""/>
                </a>
                <a href="#imagenr2">
                    <img src={foto2} alt=""/>
                </a>
                <a href="#imagenr3">
                    <img src={foto3} alt=""/>
                </a>
                <a href="#imagenr4">
                    <img src={foto4} alt=""/>
                </a>
            </div>

            <div className="light-box" id="imagenr1">  
                <a href="#imagenr5" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto1} alt=""/>
                <a href="#imagenr2" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close" >
                    X 
                </a>
            </div>

            <div className="light-box" id="imagenr2">  
                <a href="#imagenr1" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto2} alt=""/>
                <a href="#imagenr3" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenr3">  
                <a href="#imagenr2" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto3} alt=""/>
                <a href="#imagenr4" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenr4">  
                <a href="#imagenr3" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto4} alt=""/>
                <a href="#imagenr1" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>


        </div>
    )
}

export default Gallery
